/**
 * Mormors Loft — cart terms: on-page modal instead of native alert.
 * Zendesk #35925
 *
 * Covers:
 *  1) Symmetry /cart (#cartform input#terms) — alert intercept + click/submit guard
 *  2) Boost ATC mini-cart / side drawer (#boost-sd__modal-cart .boost-sd__cart--side)
 *     — inject same checkbox + block .boost-sd__btn-checkout until accepted
 *
 * Symmetry calls alert(theme.strings.cart_terms_confirmation) when
 * #cartform input#terms is unchecked. Native dialogs fail in many mobile /
 * Instagram in-app browsers. We (1) intercept that alert and (2) also bind a
 * capture-phase click handler so the modal still shows if alert override fails.
 */
(function () {
  'use strict';

  var MODAL_ID = 'ml-cart-terms-modal';
  var DRAWER_WRAP_CLASS = 'ml-drawer-terms';
  var DRAWER_CB_ID = 'ml-drawer-terms-cb';

  var TERMS_CB_SEL =
    '#cartform input#terms, #' + DRAWER_CB_ID + ', input.ml-terms-cb';

  var CHECKOUT_SEL =
    '#cartform [name="checkout"], #cartform button[name="checkout"], ' +
    '.additional-checkout-buttons input, .additional-checkout-buttons button, ' +
    'a[href*="/checkout"], ' +
    '.boost-sd__btn-checkout, button.boost-sd__btn-checkout';

  var nativeAlert = window.alert.bind(window);
  var lastFocus = null;
  var pendingCheckoutEl = null;
  var injectScheduled = false;
  var termsAccepted = false;

  function termsMessage() {
    try {
      if (window.theme && theme.strings && theme.strings.cart_terms_confirmation) {
        return theme.strings.cart_terms_confirmation;
      }
    } catch (e) {}
    return 'Du skal acceptere vilkårene og betingelserne, før du kan fortsætte.';
  }

  function agreementHtml() {
    try {
      if (window.theme && theme.strings && theme.strings.cart_terms_agreement_html) {
        return theme.strings.cart_terms_agreement_html;
      }
    } catch (e) {}
    return (
      'Jeg accepterer <a href="/pages/forretningsbetingelser" target="_blank" rel="noopener">' +
      'handelsbetingelserne</a> og <a href="/pages/persondata-og-cookiepolitik-hos-mormors-loft" ' +
      'target="_blank" rel="noopener">privatlivspolitikken</a>'
    );
  }

  function allTermsCheckboxes() {
    return Array.prototype.slice.call(document.querySelectorAll(TERMS_CB_SEL));
  }

  function termsRequiredAndUnchecked() {
    if (termsAccepted) return false;
    var boxes = allTermsCheckboxes();
    if (!boxes.length) return false;
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].checked) return false;
    }
    return true;
  }

  function setAllTermsChecked(checked) {
    termsAccepted = !!checked;
    allTermsCheckboxes().forEach(function (cb) {
      if (cb.checked === checked) return;
      cb.checked = checked;
      try {
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    });
  }

  function syncTermsFrom(source) {
    var checked = !!(source && source.checked);
    termsAccepted = checked;
    allTermsCheckboxes().forEach(function (cb) {
      if (cb === source) return;
      cb.checked = checked;
    });
  }

  function ensureModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) {
      // Keep as last body child so equal max z-index still paints above Boost
      if (existing.parentNode !== document.body || document.body.lastElementChild !== existing) {
        document.body.appendChild(existing);
      }
      return existing;
    }

    var root = document.createElement('dialog');
    root.id = MODAL_ID;
    root.className = 'ml-terms-modal';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'ml-cart-terms-modal-title');
    root.hidden = true;
    root.innerHTML =
      '<div class="ml-terms-modal__backdrop" data-ml-terms-dismiss="1"></div>' +
      '<div class="ml-terms-modal__dialog" role="document">' +
      '  <button type="button" class="ml-terms-modal__close" data-ml-terms-dismiss="1" aria-label="Luk">&times;</button>' +
      '  <h2 class="ml-terms-modal__title" id="ml-cart-terms-modal-title">Handelsbetingelser</h2>' +
      '  <p class="ml-terms-modal__body" data-ml-terms-body></p>' +
      '  <div class="ml-terms-modal__actions">' +
      '    <button type="button" class="ml-terms-modal__btn ml-terms-modal__btn--primary" data-ml-terms-accept="1">Accepter og fortsæt</button>' +
      '    <button type="button" class="ml-terms-modal__btn ml-terms-modal__btn--secondary" data-ml-terms-dismiss="1">Luk</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(root);

    root.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t) return;
      if (t.closest && t.closest('[data-ml-terms-accept]')) {
        acceptAndContinue();
        return;
      }
      if (t.closest && t.closest('[data-ml-terms-dismiss]')) {
        hide();
      }
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && root.classList.contains('is-open')) {
        hide();
      }
    });

    return root;
  }

  function show(message) {
    var root = ensureModal();
    // Always last in body + max z-index (Boost also uses 2147483647)
    document.body.appendChild(root);
    root.style.zIndex = '2147483647';
    root.style.position = 'fixed';
    var body = root.querySelector('[data-ml-terms-body]');
    if (body) body.textContent = message || termsMessage();
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.classList.add('ml-terms-modal-open');
    try {
      if (typeof root.showModal === 'function' && !root.open) {
        root.showModal();
      }
    } catch (e) {}
    var primary = root.querySelector('[data-ml-terms-accept]');
    if (primary && primary.focus) primary.focus();
  }

  function hide() {
    var root = document.getElementById(MODAL_ID);
    if (!root) return;
    root.classList.remove('is-open');
    try {
      if (typeof root.close === 'function' && root.open) root.close();
    } catch (e) {}
    document.body.classList.remove('ml-terms-modal-open');
    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 200);
    if (lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }

  function acceptAndContinue() {
    setAllTermsChecked(true);
    hide();
    window.setTimeout(function () {
      var btn = pendingCheckoutEl;
      pendingCheckoutEl = null;
      if (btn && document.contains(btn)) {
        btn.click();
        return;
      }
      btn =
        document.querySelector('#cartform [name="checkout"]') ||
        document.querySelector('#cartform button[name="checkout"]') ||
        document.querySelector('.boost-sd__btn-checkout');
      if (btn) btn.click();
    }, 50);
  }

  function isTermsAlert(msg) {
    if (typeof msg !== 'string') return false;
    var expected = termsMessage();
    if (msg === expected) return true;
    var lower = msg.toLowerCase();
    if (lower.indexOf('acceptere vilkår') !== -1) return true;
    if (lower.indexOf('vilkårene og betingelserne') !== -1) return true;
    if (lower.indexOf('handelsbeting') !== -1 && lower.indexOf('acceptere') !== -1) return true;
    if (lower.indexOf('agree') !== -1 && lower.indexOf('terms and conditions') !== -1) return true;
    return false;
  }

  window.alert = function (msg) {
    if (isTermsAlert(String(msg == null ? '' : msg))) {
      show(String(msg));
      return;
    }
    return nativeAlert(msg);
  };

  function checkoutFromEventTarget(el) {
    if (!el || !el.closest) return null;
    return el.closest(CHECKOUT_SEL);
  }

  function onCheckoutClick(evt) {
    var checkoutEl = checkoutFromEventTarget(evt.target);
    if (!checkoutEl) return;

    // Boost drawer renders async — ensure checkbox exists before evaluating
    injectDrawerTerms();

    var inDrawer = !!(
      checkoutEl.closest &&
      checkoutEl.closest('#boost-sd__modal-cart, .boost-sd__cart')
    );
    var inCartForm = !!(checkoutEl.closest && checkoutEl.closest('#cartform'));
    var hasDrawerTerms = !!document.getElementById(DRAWER_CB_ID);
    var hasCartTerms = !!document.querySelector('#cartform input#terms');

    // Only guard when terms UI applies to this checkout control
    if (inDrawer && !hasDrawerTerms) return;
    if (inCartForm && !hasCartTerms) return;
    if (!inDrawer && !inCartForm && !hasCartTerms && !hasDrawerTerms) return;

    if (!termsRequiredAndUnchecked()) return;

    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    pendingCheckoutEl = checkoutEl;
    show(termsMessage());
  }

  function onCartSubmit(evt) {
    var form = evt.target;
    if (!form || form.id !== 'cartform') return;
    if (!document.querySelector('#cartform input#terms')) return;
    if (!termsRequiredAndUnchecked()) return;
    var submitter = evt.submitter;
    if (submitter && submitter.name && submitter.name !== 'checkout') return;
    evt.preventDefault();
    evt.stopPropagation();
    pendingCheckoutEl =
      (submitter && submitter.name === 'checkout' && submitter) ||
      document.querySelector('#cartform [name="checkout"]');
    show(termsMessage());
  }

  function injectDrawerTerms() {
    var footer = document.querySelector(
      '#boost-sd__modal-cart .boost-sd__cart-footer, .boost-sd__cart--side .boost-sd__cart-footer, .boost-sd__cart .boost-sd__cart-footer'
    );
    if (!footer) return false;
    if (footer.querySelector('.' + DRAWER_WRAP_CLASS)) return true;

    var btnGroup = footer.querySelector('.boost-sd__cart-btn-group');
    var wrap = document.createElement('div');
    wrap.className = DRAWER_WRAP_CLASS + ' termsagreement';
    wrap.innerHTML =
      '<input type="checkbox" id="' +
      DRAWER_CB_ID +
      '" class="ml-terms-cb" />' +
      '<label for="' +
      DRAWER_CB_ID +
      '">' +
      agreementHtml() +
      '</label>';

    if (btnGroup && btnGroup.parentNode === footer) {
      footer.insertBefore(wrap, btnGroup);
    } else {
      footer.insertBefore(wrap, footer.firstChild);
    }

    var drawerCb = document.getElementById(DRAWER_CB_ID);
    var cartCb = document.querySelector('#cartform input#terms');
    if (drawerCb) {
      if (termsAccepted || (cartCb && cartCb.checked)) {
        drawerCb.checked = true;
        termsAccepted = true;
      }
    }

    return true;
  }

  function scheduleInject() {
    if (injectScheduled) return;
    injectScheduled = true;
    window.requestAnimationFrame(function () {
      injectScheduled = false;
      injectDrawerTerms();
    });
  }

  function bindCheckoutGuard() {
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onCartSubmit, true);

    document.addEventListener(
      'change',
      function (evt) {
        var t = evt.target;
        if (!t || !t.matches) return;
        if (!t.matches(TERMS_CB_SEL)) return;
        syncTermsFrom(t);
      },
      true
    );

    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        scheduleInject();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener(
      'click',
      function () {
        window.setTimeout(scheduleInject, 120);
        window.setTimeout(scheduleInject, 450);
      },
      true
    );

    injectDrawerTerms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCheckoutGuard);
  } else {
    bindCheckoutGuard();
  }

  window.MLCartTermsModal = {
    show: show,
    hide: hide,
    acceptAndContinue: acceptAndContinue,
    injectDrawerTerms: injectDrawerTerms
  };
})();
